<section class="h-full flex flex-col gap-2 z-0 relative  p-2 lg:pl-0">

    <div class="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2">
         <div class="flex flex-col sm:flex-row gap-2">
            <div>
                <select (change)="onSelectStatus()" [(ngModel)]="status" id="inputStatus" class="min-w-40">
                    <!-- <option value="">Select Status</option> -->
                    <option [ngValue]="true">Active</option>
                    <option [ngValue]="false">Inactive</option>
                </select>
            </div>
        </div>
        <div *ngIf="filteredThresholdList && filteredThresholdList.length">
            <h1 class="text-xs text-nowrap text-left">Showing {{(50 * currentPage) - (filteredThresholdList.length!==
                50?
                (50
                -filteredThresholdList.length) : 0) }} of {{totalResults}} entries
            </h1>
        </div>
         <div>
            <button routerLink="threshold/add" *ngIf="permissionService.hasPermission([userPermission.MANAGE_THRESHOLD])" class="btn btn-secondary">
                Add
            </button>
        </div>
    </div>

    <div class="h-full overflow-hidden p-2 flex flex-col rounded-lg bg-white dark:bg-zinc-950 border border-zinc-950/10 dark:border-white/10">
        <div class="h-full w-full overflow-hidden rounded-md ring-1 ring-zinc-950/10 dark:ring-white/10">
            <div class="flow-root h-full overflow-y-auto">
                <div class="-my-2">
                    <div class="inline-block min-w-full py-2 align-middle">
                        <table class="min-w-full border-separate border-spacing-0">
                            <thead>
                                <tr>
                                       <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        #
                                    </th>
                                    <th 
                                        *ngIf="permissionService.hasPermission([userPermission.MANAGE_THRESHOLD])"
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Action
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                         Amount
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Miles
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Trips
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Space Type
                                    </th>
                                    <th
                                        class="sticky top-0 z-10 px-3 py-1 text-left font-semibold bg-zinc-50 dark:bg-zinc-950 text-sm-dark border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="hover:bg-gray-950/5 dark:hover:bg-white/10"
                                    *ngFor="let item of filteredThresholdList | paginate: { itemsPerPage:numberOfRecords, currentPage: currentPage, totalItems:totalResults}; let i=index">
                                     <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                       {{i+1}}
                                    </td>
                                    <td class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap" *ngIf="permissionService.hasPermission([userPermission.MANAGE_THRESHOLD])">
                                        <div class="flex items-center">
                                            <a [appToolTip]="'Edit'" (click)="openThresholdEditModal(item)"
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                    stroke-width="2" stroke="currentColor"
                                                    class="size-5 hover:text-zinc-950 dark:hover:text-white text-zinc-500 dark:text-zinc-400 ">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" />
                                                </svg>
                                            </a>
                                            <div class="mx-2 h-6 w-px bg-zinc-950/10 dark:bg-white/10"></div>
                                            <a [appToolTip]="'Logs'" href="javascript:void(0)" (click)="openLogModal(item)"
                                                class="text-sm-light hover:text-zinc-950 dark:hover:text-white group flex items-center py-1 text-sm"
                                                role="menuitem" tabindex="-1" id="menu-item-0">
                                                <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-main-primary"
                                                    viewBox="0 0 48 48"><!-- Icon from IconPark Outline by ByteDance - https://github.com/bytedance/IconPark/blob/master/LICENSE -->
                                                    <g fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="4">
                                                        <path stroke-linejoin="round" d="M24 44H10a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h28a2 2 0 0 1 2 2v18m-4.5 20V31" />
                                                        <path stroke-linejoin="round" d="m31 34.5l1.5-1.5l3-3l3 3l1.5 1.5" />
                                                        <path d="M16 16h16m-16 8h8" />
                                                    </g>
                                                </svg>
                                            </a>
                                            </div>
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        ${{item.amount || ' N/A'}}
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{ item.miles ? (item.miles | number:'1.2-2') + ' mi' : '' }}
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{item.trips || ' N/A'}}
                                    </td>
                                    <td *ngIf="preSpacetypes"
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        {{((preSpacetypes[item?.spaceType]?.title)| uppercase) || ' N/A'}}
                                    </td>
                                    <td
                                        class="px-3 py-1 text-sm-light border-b border-zinc-950/10 dark:border-white/10 text-nowrap">
                                        <span [ngClass]="item.isActive ? 'badge-success':'badge-danger'">{{item.isActive ? 'Active'
                                            :
                                            'Inactive'}}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <div class="flex justify-end">
            <pagination-controls (pageChange)="onPageChange($event)" class="pagination-controls"></pagination-controls>
        </div>
    </div>

</section>
<app-company-threshold-edit-modal *ngIf="thresholdModalObj" [threshold]="thresholdModalObj"
    (onSave)="onSaveThreshold($event)" (onCloseModal)="onCloseThresholdModal()"></app-company-threshold-edit-modal>
<app-onboarding-logs-modal *ngIf="logObj" [source]="'threshold'" [tripId]="logObj" (closeModal)="logObj = null"></app-onboarding-logs-modal>